import {
  Box,
  Center,
  Group,
  PasswordInput as MantinePasswordInput,
  PasswordInputProps,
  Progress,
  Text,
} from '@mantine/core'
import { IconCheck, IconX } from '@tabler/icons-react'

export function PasswordInput(props: PasswordInputProps) {
  const value = (props.value as string | undefined) ?? ''
  const strength = getStrength(value)
  const checks = requirements.map((requirement, index) => (
    <PasswordRequirement key={index} label={requirement.label} meets={requirement.re.test(value)} />
  ))
  const bars = Array(4)
    .fill(0)
    .map((_, index) => (
      <Progress
        styles={{ section: { transitionDuration: '0ms' } }}
        value={value.length > 0 && index === 0 ? 100 : strength >= ((index + 1) / 4) * 100 ? 100 : 0}
        color={strength > 80 ? 'teal' : strength > 50 ? 'yellow' : 'red'}
        key={index}
        size={4}
      />
    ))

  return (
    <div>
      <MantinePasswordInput placeholder="Twoje hasło" label="Hasło" withAsterisk {...props} />
      <Group gap={5} grow mt="xs" mb="md">
        {bars}
      </Group>
      <PasswordRequirement label="Ma przynajmniej 6 znaków" meets={value.length > 5} />
      {checks}
    </div>
  )
}

function PasswordRequirement({ meets, label }: { meets: boolean; label: string }) {
  return (
    <Text component="div" c={meets ? 'teal' : 'red'} mt={5} size="sm">
      <Center inline>
        {meets ? <IconCheck size={14} stroke={1.5} /> : <IconX size={14} stroke={1.5} />}
        <Box ml={7}>{label}</Box>
      </Center>
    </Text>
  )
}

const requirements = [
  { re: /[0-9]/, label: 'Zawiera cyfry' },
  { re: /[a-z]/, label: 'Zawiera małą literę' },
  { re: /[A-Z]/, label: 'Zawiera dużą literę' },
  { re: /[$&+,:;=?@#|'<>.^*()%!-]/, label: 'Zawiera znak specjalny' },
]

function getStrength(password: string) {
  let multiplier = password.length > 5 ? 0 : 1

  requirements.forEach((requirement) => {
    if (!requirement.re.test(password)) {
      multiplier += 1
    }
  })

  return Math.max(100 - (100 / (requirements.length + 1)) * multiplier, 0)
}
